import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { TutorialPopup } from "../ui/tutorial-popup";
import { Box, IconButton } from "@mui/material";
import { luckyorangeTrackEven } from "../../services/lucky-orange/luckyorange-events";
import { TooltipControlled } from "../ui/tooltip-custom";
import { hideTutorialHint, isTutorialHintHidden } from "../../utils/tutorial-utils";

// svg
import { ReactComponent as IconInformation } from "../../assets/svg/information.svg";
import video from "../../assets/video/site-setting-upload-x1.5.mp4";



export const TutorialPopupUpload = ({ display }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleClickOpen = () => {
    setShowPopup(true);
    luckyorangeTrackEven("Site Settings: open hint");
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  const isHintHidden = isTutorialHintHidden("hideUploadHint");

  useEffect(() => {
    if (display && !isHintHidden) {
      setShowPopup(true);
    }
  }, []);

  const hideHint = () => {
    setShowPopup(false);
    setShowTooltip(true);
    setTimeout(() => {
      setShowTooltip(false);
    }, 3000);
    // Store the flag so it doesn't show again
    hideTutorialHint("hideUploadHint");
  };

  const handleCloseTooltip = () => {
    setShowTooltip(false);
  };

  const handleOpenTooltip = () => {
    setShowTooltip(true);
  };

  return (
    <>
      <TooltipControlled
        text="Click this button to open the hint again"
        open={showTooltip}
        handleClose={handleCloseTooltip}
        handleOpen={handleOpenTooltip}
      >
        <IconButton
          variant="outlined"
          onClick={handleClickOpen}
          sx={{ mt: "1px" }}
        >
          <IconInformation width="18px" height="18px" fill="#5D5F6A" />
        </IconButton>
      </TooltipControlled>

      {showPopup ? (
        <TutorialPopup
          title="How to upload CAD file"
          handleClose={handleClose}
          open={showPopup}
          hideHint={hideHint}
          isHintHidden={isHintHidden}
        >
          <Box sx={{ margin: "0 auto" }}>
            <video
              width="640"
              height="360"
              autoPlay
              controls
              controlsList="nodownload noremoteplayback"
              disablePictureInPicture
              muted
            >
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <Box mt="24px">
              <Typography align="left" fontSize="14px" mb="8px">
                In the popup, follow these steps to upload your CAD file:
              </Typography>
              <Box
                ml="16px"
                sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <Box
                  sx={{
                    display: "flex",
                    /* alignItems: 'center', */ gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      minWidth: "6px",
                      background: "#343745",
                      borderRadius: "50%",
                      marginTop: "7px",
                      boxShadow:
                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                    }}
                  />{" "}
                  <Typography fontSize="14px" align="left">
                    Select or drag-and-drop a file that contains a layer named
                     <strong> property_outline </strong> with the site polygon.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    /* alignItems: 'center', */ gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      minWidth: "6px",
                      background: "#343745",
                      borderRadius: "50%",
                      marginTop: "7px",
                      boxShadow:
                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                    }}
                  />{" "}
                  <Typography fontSize="14px" align="left">
                    Choose your units.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    /* alignItems: 'center', */ gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      minWidth: "6px",
                      background: "#343745",
                      borderRadius: "50%",
                      marginTop: "7px",
                      boxShadow:
                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                    }}
                  />{" "}
                  <Typography fontSize="14px" align="left">
                    Click on the map to set the site’s center.
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    /* alignItems: 'center', */ gap: "8px",
                  }}
                >
                  <Box
                    sx={{
                      width: "6px",
                      height: "6px",
                      minWidth: "6px",
                      background: "#343745",
                      borderRadius: "50%",
                      marginTop: "7px",
                      boxShadow:
                        "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
                    }}
                  />{" "}
                  <Typography fontSize="14px" align="left">
                    Adjust the site by panning or rotating via the corner
                    handles on the map.
                  </Typography>
                </Box>

                
              </Box>
              <Typography align="left" fontSize="14px" mt="8px">
                  Pan and rotate changes take effect instantly and are saved
                  automatically. If you upload a new file or make any other
                  edits in the popup, click Save File to commit those changes.
                </Typography>
            </Box>
          </Box>
        </TutorialPopup>
      ) : null}
    </>
  );
};
